<template>
  <div
    v-if="showContent"
    style="display: flex;flex-direction: column; height: 50vh; justify-content: center; align-items: center;"
  >
    <h3>This page does not exist</h3>
    <h4>or</h4>
    <h3>You don't have access to this page</h3>
    <b-button variant="link" class="px-0" @click="reloadPage()"
      >Click here to reload</b-button
    >
  </div>
  <div
    v-else
    style="display: flex; justify-content: center; align-items: center;"
  >
    <div class="sk-double-bounce bouncing2">
      <div class="sk-child sk-double-bounce1"></div>
      <div class="sk-child sk-double-bounce2"></div>
    </div>
  </div>
</template>
<script>
import router from "../../router";
export default {
  name: "model",
  components: {},
  data: function() {
    return { showContent: false };
  },
  methods: {
    reloadPage() {
      window.location.reload();
    }
  },
  mounted() {
    let path = localStorage.getItem("redirect_path");
    if (!localStorage.getItem("fns_user") || !path) {
      router.replace("/pages/login");
      return;
    }
    this.showContent = true;
    if (localStorage.getItem("reloaded")) {
      localStorage.removeItem("reloaded");
    } else {
      localStorage.setItem("reloaded", "1");
      this.reloadPage();
    }
  }
};
</script>
